var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 24,
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.067 9.5C16.067 13.0346 13.2016 15.9 9.66699 15.9C6.13237 15.9 3.26699 13.0346 3.26699 9.5C3.26699 5.96538 6.13237 3.1 9.66699 3.1C13.2016 3.1 16.067 5.96538 16.067 9.5ZM14.6852 15.0739C13.3562 16.2712 11.5967 17 9.66699 17C5.52486 17 2.16699 13.6421 2.16699 9.5C2.16699 5.35786 5.52486 2 9.66699 2C13.8091 2 17.167 5.35786 17.167 9.5C17.167 11.3164 16.5212 12.9821 15.4468 14.2798L22.167 21L21.3892 21.7778L14.6852 15.0739Z",
  fill: "#001246"
})));
export default SvgSearch;